document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header-logo-swap]');
  const heroLogo = document.querySelector('[data-hero-logo]');

  if (header) {
    if (!heroLogo) {
      header.classList.add('is-past-hero-logo');
    } else {
      let updateRequested = false;

      const updateHeaderLogo = () => {
        const headerBottom = header.getBoundingClientRect().bottom;
        const heroLogoBottom = heroLogo.getBoundingClientRect().bottom;

        header.classList.toggle('is-past-hero-logo', heroLogoBottom <= headerBottom);
        updateRequested = false;
      };

      const requestHeaderLogoUpdate = () => {
        if (updateRequested) return;
        updateRequested = true;
        window.requestAnimationFrame(updateHeaderLogo);
      };

      window.addEventListener('scroll', requestHeaderLogoUpdate, { passive: true });
      window.addEventListener('resize', requestHeaderLogoUpdate);
      updateHeaderLogo();
    }
  }

  document.querySelectorAll('.rk-mobile-menu a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const section = select.closest('[data-section-id]');
      if (!option || !section) return;

      const price = section.querySelector('[data-variant-price]');
      const compareAt = section.querySelector('[data-variant-compare-at]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const addButtonText = section.querySelector('[data-add-to-cart-text]');
      const available = option.dataset.available === 'true';

      if (price) price.textContent = option.dataset.price || '';
      if (compareAt) {
        compareAt.textContent = option.dataset.compareAtPrice || '';
        compareAt.hidden = !option.dataset.compareAtPrice;
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.classList.toggle('rk-button--disabled', !available);
      }
      if (addButtonText && addButton) {
        addButtonText.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
});
